/* eslint-disable react/require-default-props */
import React from "react";
import styled from "styled-components";
import { Badge } from "@xfrontend/xui-react-plus";

type PolicyCategoryTagProps = {
  category: "default" | "custom";
  className?: string;
};

const StyledTag = styled(Badge)`
  display: inline-block;
  border-radius: 4px;
  padding: 3px 6px;
  font-size: 14px;
  line-height: 1;
  border: 1px solid var(--x-dark-display);
  color: var(--x-gray-400);
  background-color: var(--x-bg-400);
`;

const LABEL: Record<string, string> = {
  default: "Default",
  custom: "Custom",
};

const PolicyCategoryTag = ({
  category,
  className,
}: PolicyCategoryTagProps): JSX.Element => (
  <StyledTag bg="" className={className}>
    {LABEL[category] ?? category}
  </StyledTag>
);

export default PolicyCategoryTag;
